const logoLink = "flex items-center gap-3 text-inherit no-underline transition-opacity hover:opacity-85";

const logoIcon = "h-7 w-7 shrink-0";

const logo = "text-lg font-bold text-foreground tracking-tight";

export { logoLink, logoIcon, logo };
